import { isExpirationTip } from './isExpirationTip';
import { assertNever } from 'owa-assert';
import { OwaDate } from 'owa-datetime';
import formatShortMonthDayYear from 'owa-datetime/lib/formatters/formatShortMonthDayYear';
import { LinkActionStatus } from 'owa-link-data';
import { SharingTipId } from 'owa-sharing-data';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';

export function getDisplayString(
    sharingTipId: SharingTipId,
    defaultString: string,
    refreshStatus: LinkActionStatus,
    expirationDate: OwaDate | null
): string {
    switch (sharingTipId) {
        case SharingTipId.externalRecipientCSL:
        case SharingTipId.getSharingInfoFailed:
        case SharingTipId.noPermissionSet:
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.sharingWithLargeDL:
            return defaultString;
        case SharingTipId.linkHasExpired:
        case SharingTipId.linkWillExpire:
            return getShortExpirationString(sharingTipId, refreshStatus, expirationDate);
        default:
            return assertNever(sharingTipId);
    }
}

function getShortExpirationString(
    sharingTipId: SharingTipId,
    refreshStatus: LinkActionStatus,
    expirationDate: OwaDate | null
): string {
    if (refreshStatus === LinkActionStatus.refreshFailed) {
        return strings.RefreshLinkFailedText;
    }

    if (sharingTipId === SharingTipId.linkHasExpired) {
        return strings.LinkExpiredShortText;
    }

    const dateString = formatShortMonthDayYear(expirationDate);
    return format(strings.LinkWillExpireText, dateString);
}

export function getInfoIconTooltip(
    sharingTipId: SharingTipId,
    refreshStatus: LinkActionStatus
): string | null {
    // We only offer tooltips for expired/expiring links
    if (!isExpirationTip(sharingTipId)) {
        return null;
    }

    if (refreshStatus === LinkActionStatus.refreshFailed) {
        return strings.RefreshLinkFailedTooltipText;
    }

    if (sharingTipId === SharingTipId.linkWillExpire) {
        return strings.LinkWillExpireTooltipText;
    }

    if (sharingTipId === SharingTipId.linkHasExpired) {
        return strings.LinkHasExpiredTooltipText;
    }

    return null;
}
